module.exports = __webpack_public_path__ + "static/media/golf8.765c0633.jpg";